export const en = {
    // Common
    error: 'An error occurs',
    success: 'Success',
    confirm_delete_many: 'Do you want to delete these items?',
    confirm_delete_one: 'Are you sure delete this item?',
    admin: 'Admin',
    teacher: 'Teacher',
    student: 'Student',
    class: 'Class',
    alert_go_back: 'Your changes will not be saved. Are you sure?',
    add: 'Add',

    // Form message
    email_validation_message: 'The input is not valid email',
    phone_number_message: 'Phone number must include digits only',
    required_field: 'This field is required',
    invalid_format: 'Invalid format',
    email_is_already_taken: 'Email is already taken',
    invalid_password: 'Invalid password',

    // Login
    signin: 'Signin',
    welcome: 'ABK COLLEGE',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    input_id: 'Input ID',
    input_password: 'Input password',

    // Forgot password
    forgot: 'Forgot your password?',
    forgot_password: 'Forgot password',
    reset_link_was_sent: 'A password reset link was sent to your email address',
    enter_valid_email: 'Enter a valid email address.',
    back: 'Back',
    send: 'Send',
    email_address: 'Email address',
    input_email: 'Input email',
    text_email_account:
        "Enter the email associated with your account and we'll send an email with instructions to reset your password.",
    check_email: 'Check your email',
    text_check_email: 'We have sent password recovery instructions to your email',
    open_email: 'Open email',
    skip_confirm: "Skip, i'll confirm later",

    // Reset password
    create: 'Create new password',
    reset_password: 'Reset Password',
    text_new_password: 'Your new password must be different from the previously used password.',
    confirm_password: 'Confirm Password',
    re_enter_password: 'Re-enter password',
    extra_password: 'Minimum 8 characters, at least one letter, one number and one special character',
    extra_confirm_password: 'Both passwords must match.',
    change_password_text: 'Change password successfully',

    // Header
    logout: 'Logout',

    // Sidebar
    dashboard: 'Dashboard',
    teacher_page: 'Teacher Management',
    student_page: 'Student Management',
    class_page: 'Class Management',
    learning_page: 'Learning Material Management',

    // Dashboard
    analytics: 'Analytics',
    weekly: 'Weekly',
    monthly: 'Monthly',
    analytics_user: 'Number of students using the app',
    analytics_n5: '(N5) Number of words learned',
    analytics_n4: '(N4) Number of words learned',
    teacher_dashboard: 'Teacher',
    student_dashboard: 'Student',
    class_dashboard: 'Class',

    // Overview
    overview: 'Overview',

    // Teacher management
    edit_teacher: 'Edit Teacher',
    search_teachers: 'Search Teachers',
    delete: 'Delete',
    add_new: 'Add New',
    add_to_class: 'Add to class',
    teacher_name: 'Teacher Name',
    status: 'Status',
    decentralization: 'Decentralization',
    select_decentralization: 'Select decentralization',
    action: 'Action',
    add_teacher: 'Add Teacher',
    cancel: 'Cancel',
    save: 'Save',
    ok: 'Ok',
    course: 'Course',
    input_name_add: 'Please input name',
    input_password_add: 'Please input password',
    input_class_add: 'Select class in charge',
    input_email_add: 'Please input email',
    input_phone_add: 'Please input phone number',
    message_role: 'Are you sure to change from {{val}} role to {{val1}}?',
    text_role: 'This account will {{val3}}',
    text_role_1: 'lost permission to manage system.',
    text_role_2: 'have a license system.',

    // Class management
    select_class: 'Select class in charge',
    select_teacher: 'Select teacher in charge',
    teacher_charge: 'Teacher in charge',
    input_name: 'Please input name',
    add_student: 'Add Student',
    student_name: 'Student Name',

    // Student management
    select_class_student: 'Select class in charge',
    add_student_class: 'add',
    scoreboard: 'Scoreboard',
    search_student: 'Search student',
    mobile: 'Phone number',
    edit_student: 'Edit Student',
    search_class: 'Search class',
    class_list: 'Class List',
    teacher_in_charge: 'Teacher in charge',
    add_class: 'Add To Class',
    class_name: 'Class name',
    view: 'view',
    change: 'Change',
    upload: 'Upload',
    student_list: 'Student list',
    student_number: 'Student number',
    print: 'Print',
    download: 'Download',
    time: 'Time',
    writing_result_photo: 'Writing Result Photo',
    reading_result_photo: 'Reading Result Photo',
    nickname: 'Nickname',
    nationality: 'Nationality',
    birthday: 'Birthday',
    input_nickname: 'Input nickname',
    input_nationality: 'Input nationality',
    input_birthday: 'Input birthday',

    // Kanji management
    add_kanji: 'Add new Kanji',
    edit_kanji: 'Edit Kanji',
    search_kanji: 'Search kanji',
    kanji: 'Kanji',
    input_kanji: 'Input kanji',
    level: 'Level',
    input_level: 'Input level',
    how_to_read_kanji: 'How to read Kanji',
    how_to_read_kanji_kun: 'How to read Kanji (KUN)',
    how_to_read_kanji_on: 'How to read Kanji (ON)',
    convention_kun: 'Input pronunciation of type KUN',
    convention_on: 'Input pronunciation of type ON',
    add_btn: '+ Add',
    example_sentence: 'Example sentence',
    input_example_sentence: 'Input example sentence',
    demonstrative: 'Demonstrative',
    demonstrative_help: 'The main Kanji will be placed in a **',
    input_demonstrative: 'Input demonstrative',
    learn: 'Learn',
    input_learn: 'Input learn',
    video_url: 'Video URL',
    input_video_url: 'input video URL',
    video_start: 'Video start',
    input_video_start: 'Input video start',
    video_end: 'Video end',
    input_video_end: 'Input video end',

    // Profile
    profile: 'Profile',
    account_settings: 'Account settings',
    submit: 'Submit',
    change_password: 'Change password',
    old_password: 'Old password',
    new_password: 'New password',
    full_name: 'Full name',
    confirm_password_not_match: 'Password and confirm password should be the same',

    // Notification
    notify: 'Notify',
    send_notification: 'Send Notification',
    title: 'Title',
    content: 'Content',
    input_title: 'Input title',
    input_content: 'Input notification content',
    default_title: 'Reminder from teacher',
    default_content: 'You need to keep learning!',

    // Request error message
    username_or_password_is_not_correct: 'Username or password is not correct!',
    account_is_not_active: 'Account is not active!',
    account_is_deleted_by_admin: 'Account is deleted by admin!',
    you_are_not_allowed_to_login_here: 'You are not allowed to login here!',
    user_not_found: 'User not found!',
    invalid_access_token: 'Invalid access_token!',
    email_not_found: 'Email not found!',
    email_is_valid: 'Email is valid!',
    unauthorized: 'Unauthorized!',
    permission_not_granted: 'Permission not granted!',
    invalid_class_id: 'Invalid class ID!',
    invalid_file_type: 'Invalid file type!',
    cannot_assign_admin_to_class: 'Cannot assign admin to class!',
    class_already_have_teacher: 'Class already have teacher!',
    student_is_already_assigned_to_a_class: 'Student is already assigned to a class',
    invalid_number_of_teachers: 'Invalid number of teachers!',
    invalid_spelling_word: 'Invalid spelling word!',
    invalid_kanji_word_id: 'Invalid kanji word ID!',
    learn_word_is_required: 'Learn word is required!',
    invalid_learn_convention: 'Invalid learn convention!',
    invalid_user_id: 'Invalid user ID!',
    student_cannot_be_assigned_to_more_than_one_class: 'Student cannot be assigned to more than one class!',
    invalid_data: 'Invalid data!',
    class_not_found_or_not_allowed_to_be_accessed: 'Class not found or not allowed to be accessed!',
    teacher_is_not_in_charge_of_this_class: 'Teacher is not in charge of this class!',
    student_not_found_or_not_allowed_to_be_accessed: 'Student not found or not allowed to be accessed!',
    permission_denied: 'Permission denied!',
    db_exception_occurred: 'DB exception occurred!',
    server_exception_occurred: 'Server exception occurred!',
    found_no_device_id: 'Found no device ID',
    cannot_delete_yourself: 'Cannot delete yourself',
    'Bad Request Exception': 'Bad Request!',
};
